module.exports = __webpack_public_path__ + "static/media/Screenshot_5.dd8034e7.png";